module.exports = __webpack_public_path__ + "img/four.4dbea89.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/four.jpg
// module id = ./assets/images/four.jpg
// module chunks = 2 4